import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 型材产品列表
export const setSectionProducts: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 型材产品详情
export const setSectionProductDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 型材实例
export const setSectionBarIns: Mutation<IModuleState> = (state, payload) => {
  state.sectionBarIns.data = payload.data;
  state.sectionBarIns.loading = !!payload.loading;
};

// 型材产品缩略图
export const setSectionProductThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
